import { WIZARD_STEPS_MAPPING } from 'containers/Apply/LongBeachWizard'
import { updatePercentageAndStep } from 'v2/components/XProgressBar/utils'
import React from 'react'
import StepWizard, { StepWizardChildProps } from 'react-step-wizard'
import HUDHousingIntro from './HUDHousingIntro/HUDHousingIntro'

interface Props {
    personId?: any
    updatePercentage: any
}

const HUDHousingWizardContainer: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const { percentage, wizardStep, childWizzardStep } = updatePercentageAndStep(
        WIZARD_STEPS_MAPPING.benefits,
        WIZARD_STEPS_MAPPING.benefits.hud,
        WIZARD_STEPS_MAPPING
    )
    props.updatePercentage(percentage, wizardStep, childWizzardStep)

    return (
        <StepWizard
            transitions={{
                enterRight: '',
                enterLeft: '',
                exitRight: '',
                exitLeft: '',
            }}
            isLazyMount={true}
            initialStep={1}
        >
            <HUDHousingIntro personId={props.personId} onFinish={props.nextStep} onPrevious={props.previousStep} />
        </StepWizard>
    )
}

export default HUDHousingWizardContainer
